export function filterShiftParticipantsToDeny({ shiftId, status, participantIds, }) {
    return [
        { column: 'shiftId', op: '=', value: shiftId },
        {
            column: 'participantId',
            op: 'in',
            value: participantIds,
        },
        { column: 'status', op: '!=', value: status },
    ];
}
